# PPV-продукты эфира с отметкой отмены: меню «Отменить событие» у эфира
# показывает только ещё не отменённые.
query StreamEventProducts($ids: [ID!]) {
  products(ids: $ids, types: [PPV], status: ALL, rowsPerPage: 100) {
    nodes {
      id
      title
      eventCancel {
        startedAt
      }
    }
  }
}
